import * as R from 'ramda';
import React, { useState, useCallback } from 'react';
// helpers/constants
import * as G from '../helpers';
import * as GC from '../constants';
// utilities
import { sendRequest } from '../utilities/http';
import endpointsMap from '../utilities/endpoints';
//////////////////////////////////////////////////

const useReferenceTypes = () => {
  const [referenceTypes, setReferenceTypes] = useState([]);

  const getReferenceTypesByScopeName = useCallback(async (scopeName, branchGuid) => {
    const res = await sendRequest('get', endpointsMap.referenceTypeScopes);
    const { data, status } = res;

    if (G.isResponseSuccess(status)) {
      const scopeGuid = R.compose(
        G.getGuidFromObject,
        R.find(R.propEq(scopeName, GC.FIELD_NAME)),
      )(data);

      const options = { params: { scopeGuid, [GC.FIELD_BRANCH_GUID]: branchGuid } };

      const secondRes = await sendRequest(
        'get',
        endpointsMap.availableReferenceTypesForScope,
        options,
      );

      if (G.isResponseSuccess(secondRes.status)) {
        setReferenceTypes(secondRes.data);
        return;
      }
    }

    return G.handleFailResponse(res, 'withReferenceTypes -> getReferenceTypesByScopeName');
  }, []);

  return { referenceTypes, getReferenceTypesByScopeName };
};

export const withReferenceTypes = (Component) => (props) => {
  const refTypes = useReferenceTypes();

  return (
    <Component
      {...props}
      parentState={{ referenceTypes: refTypes.referenceTypes }}
      getReferenceTypesByScopeName={refTypes.getReferenceTypesByScopeName}
    />
  );
};
